export { fetchProductDetails, fetchAllProductDetails } from "./api";
